import React, { useMemo } from 'react';
import gridCss from '../../core/utils/Grid.js';
import './RotuloSeplag.css';
import styles from './RotuloSeplag.module.scss';
import { Tooltip } from 'primereact/tooltip';
import { getRandomNumber } from '../../core/utils/Global.js';

export function InfoIcon({ messageInfo, uniqueClass }) {
    return (
        <span
            className={`${styles.icon} ${uniqueClass}`}
            data-pr-tooltip={messageInfo}
            data-pr-position="top"
        >
            <i className="pi pi-info" />
        </span>
    );
}

const RotuloSeplag = ({
    afterButton = null,
    infoMessage,
    className,
    useInput,
    style,
    ...props
}) => {
    function colClasseCss() {
        let classeCss = gridCss(props.cols ? props.cols : '12');
        return classeCss;
    }
    const orientacao = props.horizontal
        ? 'content-rotulo rotulo-horizontal'
        : 'content-rotulo rotulo-vertical';

    const label = useInput ? useInput[props.children?.props?.name]?.label : props.nome;
    const messageInfo =
        useInput && useInput[props.children?.props?.name]?.infoMessage
            ? useInput[props.children?.props?.name]?.infoMessage
            : infoMessage;
    const uniqueClass = useMemo(() => `unique_${getRandomNumber()}`, []);

    return (
        <>
            {messageInfo && <Tooltip target={`.${uniqueClass}`} />}
            <div className={colClasseCss()}>
                <div className={`${orientacao} ${className ?? ''}`}>
                    <div className="label-rotulo p-col-fixed label-destaque">
                        <label className={styles.label} style={{ position: 'relative' }}>
                            {label}
                            {props.obrigatorio ? <span className="obrigatorio">{' *'}</span> : ''}
                            {messageInfo && (
                                <InfoIcon messageInfo={messageInfo} uniqueClass={uniqueClass} />
                            )}
                            {afterButton && afterButton}
                        </label>
                    </div>
                    <div className="p-col elemento" style={{ ...style }}>
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    );
};

export default RotuloSeplag;
